import React from "react";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import { get, size, filter, sortBy, includes } from "lodash";

import { fetchPost } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";

import Loader from "../../Common/Loader";
import LogDetailsSummaryNew from "./LogDetailsSummaryNew";
import LogDetailsHuman from "./LogDetailsHuman";
import LogDetailsVehicleNew from "./LogDetailsVehicleNew";
import LogDetailsVerificationNew from "./LogDetailsVerificationNew";
import LogDetailsTemperatureNew from "./LogDetailsTemperatureNew";
import LogDetailsNotesNew from "./LogDetailsNotesNew";
import ChangeDecisionDialog from "../../Common/ChangeDecisionDialog";
import LogDetailsTabs from "./LogDetailsTabs";

import { getLov } from "../../../utils/lov";
import { fetchCreatedByUsers } from "../../../utils/event";

import {
  logDetailsTabs as tabs,
  human,
  truck,
  trailer,
} from "../../../constants/common";

import colors from "../../../assets/style/colors";

const styles = {
  container: {
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    borderRadius: "4px",
    backgroundColor: colors.white,
    margin: "0px",
    minHeight: "250px",
    height: "calc(100% - 0px)",
  },
  root: {
    zIndex: "950 !important",
  },
  dialog: {
    width: "calc(100vw - 100px)",
    maxWidth: "1200px",
    height: "calc(100vh - 100px)",
    maxHeight: "1000px",
    borderRadius: "2px",
  },
  titleBar: {
    zIndex: 1,
    height: "40px",
    margin: "15px 0px 0px 0px",
    borderBottom: "1px solid " + colors.pinkishGrey,
    display: "flex",
  },
  closeIcon: {
    margin: "18px",
    cursor: "pointer",
    opacity: "0.54",
    transform: "scale(0.85)",
  },
  contentContainer: {
    backgroundColor: colors.cardDarkBg,
    padding: "24px",
    paddingBottom: "2px",
    overflow: "auto",
  },
  infoContainer: {
    border: "1px solid " + colors.veryLighPink,
    borderRadius: "2px",
    margin: "10px 10px 30px 10px",
    padding: "0px 15px 15px 15px",
  },
  infoTitle: {
    color: colors.black54,
    background: colors.white,
    transform: "translate(12px, -12px) scale(1.0)",
    display: "inline-block",
    padding: "0px 3px",
  },
  dataBlock: {
    marginBottom: "15px",
  },
  actionBar: {
    backgroundColor: colors.cardDarkBg,
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& button": {
      margin: "-1px 15px 0px 15px",
    },
  },
  radioBtn: {
    padding: 0,
    margin: "0px 4px 0px 7px",
    transform: "scale(0.8)",
  },
  radioLabel: {
    marginRight: "20px",
  },
  verifiedIcon: {
    margin: "0px 3px",
  },
  infoItem: {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  pictureContainer: {
    height: "40px",
    display: "flex",
    alignItems: "center",
  },
  link: {
    color: colors.primary,
  },
  clickableBoxTitle: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  content: {
    padding: "14px",
    paddingTop: "35px",
    overflow: "auto",
  },
};

const LogDetailsNew = (props) => {
  const {
    classes,
    log,
    section,
    language,
    blockLevel2,
    permissions,
    dbPermissions,
  } = props;
  const [activeTab, setActiveTab] = React.useState(
    props.addTempDirectly ? tabs.temperature : tabs.summary
  );
  const [lov, setLov] = React.useState();
  const [
    identificationEventGroups,
    setIdentificationEventGroups,
  ] = React.useState();

  React.useEffect(() => {
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (get(log, ["id"])) {
      fetchIdentificationEventGroups();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get(log, ["id"])]);

  const fetchIdentificationEventGroups = async () => {
    try {
      let res = await fetchPost("new/event_groups", {
        filter: {
          parent_ids: [get(log, ["id"])],
          types: [1, 10, 11],
        },
        data: [
          "id",
          "active",
          "type",
          "profile",
          "luke_index",
          {
            name: "events",
            data: [
              "id",
              "active",
              "created_on",
              "created_by",
              "type",
              "profile",
            ],
          },
        ],
      });
      res.items = await fetchCreatedByUsers(res.items);
      setIdentificationEventGroups(get(res, ["items"]));
    } catch (e) {
      console.log(e);
    }
  };

  const refreshLog = () => {
    fetchIdentificationEventGroups();
    props.refreshLog();
  };

  const fetchLov = async () => {
    try {
      setLov({
        107: await getLov(107),
        110: await getLov(110),
        35: await getLov(35),
        36: await getLov(36),
        42: await getLov(42),
        53: await getLov(53),
        89: await getLov(89),
        135: await getLov(135),
        tags: await getLov("tags"),
      });
    } catch (e) {
      console.log(e);
    }
  };

  const overriden = {
    human: get(
      sortBy(
        filter(
          get(
            filter(
              identificationEventGroups,
              (eg) => get(eg, ["type", "id"]) === 1
            ),
            [0, "events"]
          ),
          (e) => get(e, ["type", "id"]) === 64
        ),
        (e) => -e.created_on
      ),
      [0]
    ),
    truck: get(
      sortBy(
        filter(
          get(
            filter(
              identificationEventGroups,
              (eg) => get(eg, ["type", "id"]) === 10
            ),
            [0, "events"]
          ),
          (e) => get(e, ["type", "id"]) === 64
        ),
        (e) => -e.created_on
      ),
      [0]
    ),
    trailer: get(
      sortBy(
        filter(
          get(
            filter(
              identificationEventGroups,
              (eg) => get(eg, ["type", "id"]) === 11
            ),
            [0, "events"]
          ),
          (e) => get(e, ["type", "id"]) === 64
        ),
        (e) => -e.created_on
      ),
      [0]
    ),
  };

  if (size(log) === 0) {
    return (
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={classes.container}
        alignItems="center"
        justify="center"
      >
        <Grid item>
          <Loader noDecoration />
        </Grid>
      </Grid>
    );
  }

  if (get(permissions, ["read"]) === false) {
    return null;
  }

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      className={classes.container}
    >
      <Grid item className={classes.titleBar}>
        <LogDetailsTabs
          activeTab={activeTab}
          changeTab={setActiveTab}
          section={section}
          overriden={overriden}
        />
        {!blockLevel2 && (
          <ChangeDecisionDialog
            log={log}
            refreshLog={refreshLog}
            closeDialog={props.closeFunction}
            section={section}
          />
        )}
      </Grid>
      <Grid item xs className={classes.content}>
        {activeTab === tabs.summary && (
          <LogDetailsSummaryNew
            section={section}
            log={log}
            language={language}
            refreshLog={refreshLog}
            blockLevel2={blockLevel2}
            permissions={permissions}
            dbPermissions={dbPermissions}
          />
        )}
        {activeTab === tabs.human && (
          <LogDetailsHuman
            section={section}
            language={language}
            log={log}
            lov={lov}
            refreshLog={refreshLog}
            overriden={get(overriden, [human])}
            blockLevel2={blockLevel2}
            permissions={permissions}
            dbPermissions={dbPermissions}
          />
        )}
        {includes([tabs.vehicle, tabs.trailer], activeTab) && (
          <LogDetailsVehicleNew
            section={section}
            language={language}
            log={log}
            lov={lov}
            refreshLog={refreshLog}
            typeId={activeTab === tabs.vehicle ? 10 : 11}
            overriden={get(overriden, [
              activeTab === tabs.vehicle ? truck : trailer,
            ])}
          />
        )}
        {activeTab === tabs.verification && (
          <LogDetailsVerificationNew
            language={language}
            log={log}
            identificationEventGroup={get(
              filter(
                identificationEventGroups,
                (eg) => get(eg, ["type", "id"]) === 1
              ),
              [0]
            )}
            overriden={get(overriden, [human])}
            blockLevel2={blockLevel2}
            refreshLog={refreshLog}
          />
        )}
        {activeTab === tabs.temperature && (
          <LogDetailsTemperatureNew
            language={language}
            log={log}
            identificationEventGroup={get(
              filter(
                identificationEventGroups,
                (eg) => get(eg, ["type", "id"]) === 1
              ),
              [0]
            )}
            overriden={get(overriden, [human])}
            blockLevel2={blockLevel2}
            refreshLog={refreshLog}
            addTempDirectly={props.addTempDirectly}
          />
        )}
        {activeTab === tabs.notes && (
          <LogDetailsNotesNew
            log={log}
            refreshLog={refreshLog}
            permissions={permissions}
          />
        )}
        {/* {section === driveInOut ? (
            this.state.tabValue === 1 ? (
              <LogDetailsDriverNew
                section={this.props.section}
                classes={classes}
                language={this.props.language}
                details={this.getProfileProps(driver)}
                updateHistory={this.props.updateHistory}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
              />
            ) : this.state.tabValue === 2 ? (
              <LogDetailsVehicle
                section={this.props.section}
                type={truck}
                language={this.props.language}
                details={this.getProfileProps(truck)}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                refreshDetectionEventGroup={this.refreshDetectionEventGroup}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
              />
            ) : this.state.tabValue === 3 ? (
              <LogDetailsVehicle
                section={this.props.section}
                type={trailer}
                language={this.props.language}
                details={this.getProfileProps(trailer)}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                refreshDetectionEventGroup={this.refreshDetectionEventGroup}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
              />
            ) : this.state.tabValue === 4 ? (
              <LogDetailsNotes
                notes={this.getNotes()}
                user={this.props.user}
                addNote={this.addNote}
                loading={this.state.loadingNotes}
                eventGroupIds={this.getEventGroupIds()}
                log={this.props.log}
              />
            ) : (
              <LogDetailsSummary
                section={this.props.section}
                log={log}
                language={this.props.language}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
              />
            )
          ) : section === walkInOut ? (
            this.state.tabValue === 1 ? (
              <LogDetailsDriverNew
                section={this.props.section}
                classes={classes}
                language={this.props.language}
                details={this.getProfileProps(human)}
                updateHistory={this.props.updateHistory}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
              />
            ) : this.state.tabValue === 2 ? (
              <LogDetailsVerification
                section={this.props.section}
                log={this.props.log}
                language={this.props.language}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                powerUserMode={this.props.common.powerUserModeEnabled}
              />
            ) : this.state.tabValue === 3 ? (
              <LogDetailsTemperature
                details={this.getProfileProps(human)}
                log={log}
                language={this.props.language}
              />
            ) : this.state.tabValue === 4 ? (
              <LogDetailsNotes
                notes={this.getNotes()}
                user={this.props.user}
                addNote={this.addNote}
                loading={this.state.loadingNotes}
                eventGroupIds={this.getEventGroupIds()}
                log={this.props.log}
              />
            ) : (
              <LogDetailsSummary
                section={this.props.section}
                log={log}
                language={this.props.language}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
              />
            )
          ) : (
            <></>
          )} */}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(LogDetailsNew));
